module.exports = __webpack_public_path__ + "img/213-gibraltar.abba45d2.svg";